export const REPORTS_EXPORT_PEOPLE_LIST = 'Export People List';
export const REPORTS_EXPORT_PROJECT_LIST = 'Export Project List';
export const REPORTS_EXPORT_PEOPLE_GANTT = 'Export People Gantt';
export const REPORTS_EXPORT_PROJECT_GANTT = 'Export Project Gantt';
